import CryptoJS from 'crypto-js';
import { KEY } from '../Constants';

export const getUserData = () => {
    const data = localStorage.userData;
    if (data) {
        const bytes = CryptoJS.AES.decrypt(data.toString(), KEY);
        const decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
        if (!decryptedData) {
            return {};
        }
        return decryptedData;
    } else {
        return {};
    }
};

export const setUserData = (data) => {
    const cipherText = CryptoJS.AES.encrypt(JSON.stringify(data), KEY);
    localStorage.setItem('userData', cipherText.toString());
};

export const setWalletBet = (wallet, bet) => {
    const params = getUserData();
    params.wallet = wallet;
    params.currentBet = bet;
    setUserData(params);
};

export const setWallet = (wallet) => {
    const params = getUserData();
    params.wallet = wallet;
    setUserData(params);
};

export const setBet = (bet) => {
    const params = getUserData();
    params.currentBet = bet;
    setUserData(params);
};
